const o = (e) => e.type === "object" && e.properties !== null, t = (e) => e.type === "array" && e.items !== null, n = (e) => !!e.oneOf, p = (e) => typeof e != "boolean";
export {
  t as isArrayType,
  o as isObjectType,
  n as isOneOf,
  p as isSchemaNotBoolean
};
